/**
 * 辐射车辆
 */
import { RADIALVEHICLE } from '../types';

export default {
    name: `${RADIALVEHICLE}`,
    path: '/radialVehicle',
    component: () => import(/* webpackChunkName: 'radialVehicle' */ '@/views/radialVehicle/'),
    redirect: { name: `${RADIALVEHICLE}Index` },
    meta: {
        title: '辐射车辆',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${RADIALVEHICLE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'radialVehicle' */ '@/views/radialVehicle/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${RADIALVEHICLE}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'radialVehicle' */ '@/views/radialVehicle/detail/Detail.vue'),
        // },
    ],
};
